var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getHighestRating, ratingWeightage, sortData, } from "@domains/utils/sort";
import * as moment from "moment";
export var EFilterType;
(function (EFilterType) {
    EFilterType["Date"] = "Date";
    EFilterType["LesserThan"] = "lesserThan";
    EFilterType["GreaterThan"] = "greaterThan";
    EFilterType["Between"] = "between";
    EFilterType["Rating"] = "Rating";
    EFilterType["AtLeastOne"] = "atleast_one";
})(EFilterType || (EFilterType = {}));
export var applySortFilter = function (data, filterData, sort) {
    var newData = JSON.parse(JSON.stringify(data));
    if ((filterData === null || filterData === void 0 ? void 0 : filterData.length) > 0) {
        newData = filter(newData, filterData);
    }
    if (sort) {
        newData = sortData(sort, newData);
    }
    return newData;
};
export var updatedapplySortFilter = function (data, filterData, sort) {
    var newData = JSON.parse(JSON.stringify(data));
    if ((filterData === null || filterData === void 0 ? void 0 : filterData.length) > 0) {
        newData = updatedFilter(newData, filterData);
    }
    if (sort) {
        newData = sortData(sort, newData);
    }
    return newData;
};
export var applySortFilterOrderbook = function (data, filterData, sort) {
    var newData = JSON.parse(JSON.stringify(data));
    if (filterData.length > 0) {
        newData = filterForOrderBook(newData, filterData);
    }
    if (sort) {
        newData = sortData(sort, newData);
    }
    return newData;
};
export default function filter(data, filterState) {
    return __spreadArray([], __read(data), false).filter(function (e) {
        return filterState.some(function (f) {
            var fVal = typeof f.key === "string"
                ? e[f.key]
                : f.key.reduce(function (a, k) { return a[k]; }, e);
            if (f.type && f.type === "Date") {
                return filterDataAccordingToDate(fVal, f.value);
            }
            else if (f.type && f.type === "lesserThan") {
                return typeof f.key === "string"
                    ? Number(e[f.key]) < Number(f.value)
                    : null;
            }
            else if (f.type && f.type === "greaterThan") {
                return typeof f.key === "string"
                    ? Number(e[f.key]) > Number(f.value)
                    : null;
            }
            else if (f.type && f.type === "between") {
                var bounds = f.value.split(",");
                return typeof f.key === "string"
                    ? Number(e[f.key]) >= Number(bounds[0]) &&
                        Number(e[f.key]) <= Number(bounds[1])
                    : null;
            }
            else if (f.type && f.type === "Rating") {
                return typeof f.key === "string"
                    ? ratingWeightage[getHighestRating(e[f.key])] < f.value
                    : null;
            }
            else if (f.type && f.type === "atleast_one") {
                return fVal === null || fVal === void 0 ? void 0 : fVal.includes(f.value);
            }
            else {
                return Array.isArray(f.value)
                    ? f.value.length === 0 || f.value.indexOf(fVal) > -1
                    : fVal === f.value;
            }
        });
    });
}
export function updatedFilter(data, filterState) {
    var map = new Map();
    filterState === null || filterState === void 0 ? void 0 : filterState.map(function (el) {
        map.has(el.key)
            ? map.set(el.key, __spreadArray(__spreadArray([], __read(map.get(el.key)), false), [el], false))
            : map.set(el.key, [el]);
    });
    return __spreadArray([], __read(data), false).filter(function (e) {
        var final = true;
        map.forEach(function (val, key) {
            final =
                final &&
                    val.some(function (ele) {
                        var fVal = typeof key === "string"
                            ? e[key]
                            : key.reduce(function (a, k) { return a[k]; }, e);
                        if (ele.type && ele.type === "Date") {
                            return filterDataAccordingToDate(fVal, ele.value);
                        }
                        else if (ele.type && ele.type === "lesserThan") {
                            return typeof key === "string"
                                ? Number(e[key]) < Number(ele.value)
                                : null;
                        }
                        else if (ele.type && ele.type === "greaterThan") {
                            return typeof key === "string"
                                ? Number(e[key]) > Number(ele.value)
                                : null;
                        }
                        else if (ele.type && ele.type === "between") {
                            var bounds = ele.value.split(",");
                            return typeof key === "string"
                                ? Number(e[key]) >= Number(bounds[0]) &&
                                    Number(e[key]) <= Number(bounds[1])
                                : null;
                        }
                        else if (ele.type && ele.type === "Rating") {
                            return typeof key === "string"
                                ? ratingWeightage[getHighestRating(e[key])] < ele.value
                                : null;
                        }
                        else if (ele.type && ele.type === "atleast_one") {
                            return fVal === null || fVal === void 0 ? void 0 : fVal.includes(ele.value);
                        }
                        else {
                            return Array.isArray(ele.value)
                                ? ele.value.length === 0 || ele.value.indexOf(fVal) > -1
                                : fVal === ele.value;
                        }
                    });
        });
        return final;
    });
}
export function filterForOrderBook(data, filterState) {
    var trsTyp = [];
    var prdTyp = [];
    filterState.forEach(function (x, i) {
        var _a;
        if (i == 0) {
            prdTyp.push(x);
            // } else if (x.key == "prdCode" || x.key == "prCd") {
        }
        else if (((_a = prdTyp[0]) === null || _a === void 0 ? void 0 : _a.key) == x.key) {
            prdTyp.push(x);
        }
        else {
            trsTyp.push(x);
        }
    });
    var productsData = (prdTyp === null || prdTyp === void 0 ? void 0 : prdTyp.length) > 0 ? filter(data, prdTyp) : data;
    if ((trsTyp === null || trsTyp === void 0 ? void 0 : trsTyp.length) > 0) {
        return filter(productsData, trsTyp);
    }
    return productsData;
}
var filterDataAccordingToDate = function (fVal, periodVal) {
    if (fVal && periodVal) {
        var splitPeriod = periodVal.split("to");
        return moment(fVal).isBetween(splitPeriod[0], splitPeriod[1], undefined, "[]");
    }
};
export var claculatePeriod = function (period, format, CustomDateFilter, isNext) {
    // "DD-MMM-YYYY"
    if (CustomDateFilter) {
        return period;
    }
    else if (period === "ThisWeek") {
        return "".concat(moment().startOf("week").format(format), "to").concat(moment().format(format));
    }
    else if (period === "ThisMonth") {
        return "".concat(moment().startOf("month").format(format), "to").concat(moment()
            .endOf("month")
            .format(format));
    }
    else if (period === "LastMonth") {
        return "".concat(moment()
            .subtract(1, "months")
            .startOf("month")
            .format(format), "to").concat(moment()
            .subtract(1, "months")
            .endOf("month")
            .format(format));
    }
    else if (period === "ThisQuarter") {
        return "".concat(moment()
            .quarter(moment().quarter())
            .startOf("quarter")
            .format(format), "to").concat(moment()
            .quarter(moment().quarter())
            .endOf("quarter")
            .format(format));
    }
    else if (isNext) {
        var splitPeriod = period.split("-");
        return "".concat(moment().format(format), "to").concat(moment()
            .add(splitPeriod[1], "months")
            .format(format));
    }
    else {
        var splitPeriod = period.split("-");
        return "".concat(moment()
            .subtract(splitPeriod[1], "months")
            .format(format), "to").concat(moment().format(format));
    }
};
export var calculatePeriodEventCalendar = function (period, format, CustomDateFilter, isNext) {
    // "DD-MMM-YYYY"
    if (CustomDateFilter) {
        return period;
    }
    else if (period === "ThisWeek") {
        return "".concat(moment().format(format), " to ").concat(moment()
            .add(7, "days")
            .format(format));
    }
    else if (period === "ThisMonth") {
        return "".concat(moment().format(format), " to ").concat(moment()
            .add(30, "days")
            .format(format));
    }
    else if (period === "LastMonth") {
        return "".concat(moment().subtract(1, "months").format(format), "to").concat(moment()
            .subtract(1, "months")
            .endOf("month")
            .format(format));
    }
    else if (period === "ThisQuarter") {
        return "".concat(moment().format(format), " to ").concat(moment()
            .add(90, "days")
            .format(format));
    }
    else if (isNext) {
        var splitPeriod = period.split("-");
        return "".concat(moment().format(format), "to").concat(moment()
            .add(splitPeriod[1], "months")
            .format(format));
    }
    else {
        var splitPeriod = period.split("-");
        return "".concat(moment()
            .subtract(splitPeriod[1], "months")
            .format(format), "to").concat(moment().format(format));
    }
};
export var flattenArray = function (arr) {
    var e_1, _a;
    var result = [];
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var item = arr_1_1.value;
            if (Array.isArray(item)) {
                // Recursively flatten nested arrays
                result = result.concat(flattenArray(item));
            }
            else {
                result.push(item);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
};
